<template>
  <v-dialog :value="value" @input="onInput" max-width="420px">
    <v-card>
      <v-card-title class="white--text primary">
        Club QR Code
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="text-center pt-6">
        <v-overlay :value="qrLoading" :opacity="0.9" :color="'#FFFFFF'">
          <v-progress-circular color="#FFB300" indeterminate size="48"></v-progress-circular>
        </v-overlay>
        <div class="title mb-1">{{ name }}</div>
        <img
          v-if="qrDataUrl"
          :src="qrDataUrl"
          :alt="name + ' QR code'"
          width="240"
          height="240"
          class="qr-image"
        />
        <div class="caption mt-3" style="word-break: break-all">
          <a :href="publicUrl" target="_blank">{{ publicUrl }}</a>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text color="grey" @click="close">Close</v-btn>
        <v-btn color="primary" depressed :disabled="!qrDataUrl" @click="downloadQr">
          <v-icon left small>mdi-download</v-icon>
          Download PNG
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import QRCode from "qrcode";

export default {
  name: "ClubQrCode",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    uuid: {
      type: String,
      default: "",
    },
    name: {
      type: String,
      default: "",
    },
  },
  data: function() {
    return {
      qrDataUrl: "",
      qrLoading: false,
    };
  },
  computed: {
    publicUrl() {
      const origin = window.location.origin || "https://mylions306d6.org";
      return `${origin}/club-members/${this.uuid}`;
    },
  },
  watch: {
    value(val) {
      if (val) {
        this.generateQr();
      } else {
        this.qrDataUrl = "";
      }
    },
  },
  methods: {
    onInput(val) {
      this.$emit("input", val);
    },
    close() {
      this.$emit("input", false);
    },
    generateQr() {
      this.qrLoading = true;
      QRCode.toDataURL(this.publicUrl, { width: 480, margin: 1 })
        .then((url) => {
          this.qrDataUrl = url;
          this.qrLoading = false;
        })
        .catch(() => {
          this.qrLoading = false;
        });
    },
    downloadQr() {
      if (!this.qrDataUrl) {
        return;
      }
      const link = document.createElement("a");
      link.download = `${this.name || "club"}-qrcode.png`;
      link.href = this.qrDataUrl;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
  },
};
</script>

<style scoped>
.qr-image {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
}
</style>